import React, { useMemo } from "react";
import { Formik } from "formik";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { MarketingTable } from "./marketing-table/MarketingTable";
import { useMarketingUIContext } from "./MarketingUIContext";

export default function MarketingCard() {
  
  const marketingUIContext = useMarketingUIContext();
  const marketingUIProps = useMemo(() => {
    return {
      ids: marketingUIContext.ids,
      queryParams: marketingUIContext.queryParams,
      setQueryParams: marketingUIContext.setQueryParams,
      newBannerButtonClick: marketingUIContext.newBannerButtonClick,
    };
  }, [marketingUIContext]);

  return (
    <Card>
      <CardHeader title='Marketing Materials'>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={marketingUIProps.newBannerButtonClick}>
            <i className="fas fa-plus-circle"></i> Add New Banner
          </button>
        </CardHeaderToolbar>
      </CardHeader>{" "}  
      <CardBody>
        <Formik
          initialValues={{
            searchText: "",
          }}
          onSubmit={(values) => {
            marketingUIProps.setQueryParams({
              ...marketingUIProps.queryParams,
              search: values.searchText,
              pageNumber:1,
              pageSize:10
            })
          }}
        >
          {({ values, handleSubmit, handleBlur, handleChange, setFieldValue }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">
                
                <div className="col-lg-12">
                  <div className="input-icon">
                    <input
                      type="text"
                      className="form-control"
                      name="searchText"
                      placeholder="Search..."
                      onBlur={handleBlur}
                      value={values.searchText.trim()}
                      onChange={(e) => {
                        setFieldValue("searchText", e.target.value.trim());
                        handleSubmit();
                      }}
                    />
                    <span>
                      <i className="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
        <MarketingTable />
      </CardBody>
    </Card>
  );
}
